// @flow
import { ReducerRegistry } from "../../../base/redux";
import { RECONNECT_HIT_TIMER } from "../../../webjam/constant";
import { FEATURE_CUSTOM_REDUX_V3, tourGuideActions, tourGuideVisibilityActions } from "../../constant";
import { DeviceInfoStatus, prejoinDeviceCalculateFlag } from "../../Utils";
import {
  SET_ALWAYS_SHOW_PRE_JOINING,
  SET_AUTO_MANAGE_HOST_TRIGGER,
  SET_HOST_EVENT_RECEIVED,
  SET_HOST_HANGUP_AUTO_CONNECT,
  SET_HOST_HANGUP_EVENT_RECEIVED,
  SET_IS_DEVICE_CONNECTING,
  SET_IS_EVENT_REQUESTING_LOADER,
  SET_IS_MODERATOR_THIRD_PARTY_LISTEN,
  SET_IS_PARTICIPANT_THIRD_PARTY_LISTEN,
  SET_IS_WEBSOCKET_RECONNECTING,
  SET_LOCAL_AUTO_CONNECT,
  SET_LOCAL_BUFFER_VALUE,
  SET_PREJOIN_AVAILABLE_DEVICES,
  SET_PREJOIN_DEVICE_MESSAGE,
  SET_PREJOIN_DEVICE_PING_CALCULATE,
  SET_PREJOIN_LOADER,
  SET_PREJOIN_STEPS_RUNNING,
  SET_PREJOIN_SUBSCRIPTION_UI,
  SET_SHOW_RTA_JAM_EMAIL_INVITE_POPUP,
  SET_SHOW_RTA_JAM_INVITE_POPUP,
  SET_USER_PREJOIN_ALL_SET,
  SET_HIDE_WEBJAM_CONNECTED_MESSAGE,
  SET_USER_STATIC_DEVICE_ID,
  SET_TOUR_GUIDE_TYPE,
  SET_TOUR_GUIDE_VISIBILITY,
  SET_SHOW_INVITED_USER_REGISTRATION_MODAL,
  SET_INVITED_USER_M_STATE,
  SET_SHOW_DEVICE_HELPING_GUIDE,
  SET_JAMMING_CAPABILITY_STATE,
  SET_INVITED_USER_CONFIRM,
  SET_PREJOIN_SCREEN_USER_ROUTE,
  SET_USER_MAKE_ROOM_PAYMENT,
  SET_MY_DEVICES_DATA,
  SET_IS_MIXER_MUTE_BY_DEFAULT,
  SET_IS_JOIN_AUDIO_TO_MUTE,
  SHOW_TUTORIAL_MODAL,
  SET_USER_HANGUP_STATUS,
  SET_CONFIRMATION_MODAL_PROPS,
  SET_SERVER_CONNECT_REHIT,
  SET_DISABLE_VIEW_TOGGLE,
  SET_LIVE_STREAMING_STATUS,
  SET_PREJOIN_DEVICE_CONNECT_TIME,
  SET_DEVICE_ERROR_INFO,
  SET_IS_CHINA_REGION,
  SET_SHOW_DEVICE_PREJOIN_CONNECTION,
  SET_PREJOIN_CONNECTION_STAMP,
  SET_DOWNLOAD_TITLE,
  SET_WHITEBOARD_OPEN_CLICKED,
  SET_PREMEETING_SUBSCRIPTION_UI,
  SET_IS_NAT_TYPE,
  SET_MANUAL_BOX_PROCESS,
  SET_IS_DISCONNECT_LISTENED,
  OPEN_DIALOG_FROM_SOCIAL,
  UPDATE_LANGUAGE_FROM_SOCIAL,
  SET_SOUND_CARDS_LIST,
  SET_RECORDING_DETAILS,
  SET_HIT_FIREWALL_API
} from "./actionType";
import { updateLanguage } from "../../constant-Utils";

ReducerRegistry.register(FEATURE_CUSTOM_REDUX_V3, (state = {
  autoManageHostTrigger: true,
  localAutoConnect: false,
  isDeviceConnecting: false,
  isParticipantThirdPartyListen: false,
  isModeratorThirdPartyListen: false,
  isEventRequestingLoader: "",
  hostEventReceived: "",
  hostHangupEventReceived: false,
  hangupActionType: 0,
  showPrejoinLoader: false,
  hostHangupAutoConnect: false,
  localBuffervalue: false,
  isWebsocketReconnecting: RECONNECT_HIT_TIMER,
  prejoinDeviceMessages: {
    show: false,
    messages: {}
  },
  prejoinAvailableDevice: [],
  prejoinDeviceStepsRunning: false,
  prejoinDeviceStepsRunningFlag: "",
  lastPrejoinInfoCode: "",
  prejoinSubscription: {
    show_basic: false,
    show_premium: false
  },
  showRtaJamInvitePopup: false,
  showRtaJamEmailInvitePopup: false,
  alwaysShowPreJoining: true,
  prejoinDevicePingCalculation: prejoinDeviceCalculateFlag.DEFAULT,
  userBoxStaticDeviceId: "",
  userPrejoinAllSet: false,
  hideWebjamConnectedMessage: false,
  tourGuideType: tourGuideActions.USER_EMPTY,
  tourGuideVisibility: tourGuideVisibilityActions.TOUR_EMPTY,
  isInvitedUserMState: false,
  showDeviceHelpingGuide: false,
  isJammingCapability: false,
  invitedUserConfirm: "",
  prejoinScreenUserRoute: "",
  userMakeRoomPayment: false,
  myDevicesData: {},
  isMixerMuteByDefault: true,
  isPreJoinAudioToMute: false,
  showTutorial: false,
  userHangupStatus: "",
  confirmationModalProps: {
    isShow: false,
    title: "",
    content: "",
    showOkButton: false,
    showCancelButton: false
  },
  serverConnectRehit: false,
  disableViewToggle: false,
  liveStreamingStatus: false,
  prejoinDeviceConnectTime: 0,
  boxDeviceErrorInfo: {
    error: [],
    type: DeviceInfoStatus.DEFAULT
  },
  isChinaRegion: false,
  showDevicePreConnection: false,
  prejoinConnectStamp: 0,
  downloadTitle: "",
  isWhiteboardOpenClicked: false,
  isPremeetingSubscriptionUI: false,
  isNatType: {
    type3: false,
    type3Data: {}
  },
  manualBoxProcess: {
    isRunning: false,
    processData: {}
  },
  isDisconnectListened: false,
  socialSettingDialogStatus: false,
  streamingInitiator: "",
  currentSoundCard: "",
  soundCards: [],
  recordingDetails: {},
  hitFirewallApi: false,
}, action) => {
  switch (action.type) {
    case SET_AUTO_MANAGE_HOST_TRIGGER:
      return {
        ...state,
        autoManageHostTrigger: action.autoManageHostTrigger
      };
    case SET_LOCAL_AUTO_CONNECT:
      return {
        ...state,
        localAutoConnect: action.localAutoConnect
      };
    case SET_IS_DEVICE_CONNECTING:
      return {
        ...state,
        isDeviceConnecting: action.isDeviceConnecting
      };
    case SET_IS_PARTICIPANT_THIRD_PARTY_LISTEN:
      return {
        ...state,
        isParticipantThirdPartyListen: action.isParticipantThirdPartyListen
      };
    case SET_IS_MODERATOR_THIRD_PARTY_LISTEN:
      return {
        ...state,
        isModeratorThirdPartyListen: action.isModeratorThirdPartyListen
      };
    case SET_IS_EVENT_REQUESTING_LOADER:
      return {
        ...state,
        isEventRequestingLoader: action.isEventRequestingLoader
      };
    case SET_HOST_EVENT_RECEIVED:
      return {
        ...state,
        hostEventReceived: action.hostEventReceived
      };
    case SET_HOST_HANGUP_EVENT_RECEIVED:
      return {
        ...state,
        hostHangupEventReceived: action.hostHangupEventReceived,
        hangupActionType: action.hangupActionType
      };
    case SET_PREJOIN_LOADER:
      return {
        ...state,
        showPrejoinLoader: action.showPrejoinLoader
      };
    case SET_HOST_HANGUP_AUTO_CONNECT:
      return {
        ...state,
        hostHangupAutoConnect: action.hostHangupAutoConnect
      };
    case SET_LOCAL_BUFFER_VALUE:
      return {
        ...state,
        localBuffervalue: action.localBuffervalue
      };
    case SET_PREJOIN_DEVICE_MESSAGE:
      return {
        ...state,
        prejoinDeviceMessages: action.prejoinDeviceMessages
      };
    case SET_PREJOIN_AVAILABLE_DEVICES:
      return {
        ...state,
        prejoinAvailableDevice: action.prejoinAvailableDevice
      };

    case SET_PREJOIN_STEPS_RUNNING:
      return {
        ...state,
        prejoinDeviceStepsRunning: action.prejoinDeviceStepsRunning,
        prejoinDeviceStepsRunningFlag: action.prejoinDeviceStepsRunningFlag || "",
        lastPrejoinInfoCode: action.lastPrejoinInfoCode || ""
      };

    case SET_PREJOIN_SUBSCRIPTION_UI:
      return {
        ...state,
        prejoinSubscription: action.prejoinSubscription
      };
    case SET_IS_WEBSOCKET_RECONNECTING:
      return {
        ...state,
        isWebsocketReconnecting: action.isWebsocketReconnecting
      };
    case SET_SHOW_RTA_JAM_INVITE_POPUP:
      return {
        ...state,
        showRtaJamInvitePopup: action.showRtaJamInvitePopup,
      }
    case SET_SHOW_RTA_JAM_EMAIL_INVITE_POPUP:
      return {
        ...state,
        showRtaJamEmailInvitePopup: action.showRtaJamEmailInvitePopup
      }
    case SET_ALWAYS_SHOW_PRE_JOINING:
      return {
        ...state,
        alwaysShowPreJoining: action.alwaysShowPreJoining
      }
    case SET_PREJOIN_DEVICE_PING_CALCULATE:
      return {
        ...state,
        prejoinDevicePingCalculation: action.prejoinDevicePingCalculation
      }
    case SET_USER_STATIC_DEVICE_ID:
      return {
        ...state,
        userBoxStaticDeviceId: action.userBoxStaticDeviceId
      }
    case SET_USER_PREJOIN_ALL_SET:
      return {
        ...state,
        userPrejoinAllSet: action.userPrejoinAllSet
      }
    case SET_HIDE_WEBJAM_CONNECTED_MESSAGE:
      return {
        ...state,
        hideWebjamConnectedMessage: action.hideWebjamConnectedMessage
      }
    case SET_TOUR_GUIDE_TYPE:
      return {
        ...state,
        tourGuideType: action.tourGuideType
      }
    case SET_TOUR_GUIDE_VISIBILITY:
      return {
        ...state,
        tourGuideVisibility: action.tourGuideVisibility
      }
    case SET_INVITED_USER_M_STATE:
      return {
        ...state,
        isInvitedUserMState: action.isInvitedUserMState
      }
    case SET_SHOW_DEVICE_HELPING_GUIDE:
      return {
        ...state,
        showDeviceHelpingGuide: action.showDeviceHelpingGuide
      }
    case SET_JAMMING_CAPABILITY_STATE:
      return {
        ...state,
        isJammingCapability: action.isJammingCapability
      }
    case SET_INVITED_USER_CONFIRM:
      return {
        ...state,
        invitedUserConfirm: action.invitedUserConfirm
      }
    case SET_PREJOIN_SCREEN_USER_ROUTE:
      return {
        ...state,
        prejoinScreenUserRoute: action.prejoinScreenUserRoute
      }
    case SET_USER_MAKE_ROOM_PAYMENT:
      return {
        ...state,
        userMakeRoomPayment: action.userMakeRoomPayment
      }
    case SET_MY_DEVICES_DATA:
      return {
        ...state,
        myDevicesData: action.myDevicesData
      }
    case SET_IS_MIXER_MUTE_BY_DEFAULT:
      return {
        ...state,
        isMixerMuteByDefault: action.isMixerMuteByDefault
      }
    case SET_IS_JOIN_AUDIO_TO_MUTE:
      return {
        ...state,
        isPreJoinAudioToMute: action.isPreJoinAudioToMute
      }
    case SHOW_TUTORIAL_MODAL:
      return {
        ...state,
        showTutorial: action.showTutorial
      }
    case SET_USER_HANGUP_STATUS:
      return {
        ...state,
        userHangupStatus: action.userHangupStatus
      }
    case SET_CONFIRMATION_MODAL_PROPS:
      return {
        ...state,
        confirmationModalProps: action.confirmationModalProps
      }
    case SET_SERVER_CONNECT_REHIT:
      return {
        ...state,
        serverConnectRehit: action.serverConnectRehit
      }
    case SET_DISABLE_VIEW_TOGGLE:
      return {
        ...state,
        disableViewToggle: action.disableViewToggle
      }
    case SET_LIVE_STREAMING_STATUS:
      return {
        ...state,
        liveStreamingStatus: action.liveStreamingStatus,
        streamingInitiator: action.streamingInitiator
      }

    case SET_IS_CHINA_REGION:
      return {
        ...state,
        isChinaRegion: action.isChinaRegion
      }
    case SET_PREJOIN_DEVICE_CONNECT_TIME:
      return {
        ...state,
        prejoinDeviceConnectTime: action.prejoinDeviceConnectTime
      }
    case SET_DEVICE_ERROR_INFO:
      return {
        ...state,
        boxDeviceErrorInfo: action.boxDeviceErrorInfo
      }
    case SET_SHOW_DEVICE_PREJOIN_CONNECTION:
      return {
        ...state,
        showDevicePreConnection: action.showDevicePreConnection
      }
    case SET_PREJOIN_CONNECTION_STAMP:
      return {
        ...state,
        prejoinConnectStamp: action.prejoinConnectStamp
      }
    case SET_DOWNLOAD_TITLE:
      return {
        ...state,
        downloadTitle: action.downloadTitle
      }
    case SET_WHITEBOARD_OPEN_CLICKED:
      return {
        ...state,
        isWhiteboardOpenClicked: action.isWhiteboardOpenClicked
      }
    case SET_PREMEETING_SUBSCRIPTION_UI:
      return {
        ...state,
        isPremeetingSubscriptionUI: action.isPremeetingSubscriptionUI
      }
    case SET_IS_NAT_TYPE:
      return {
        ...state,
        isNatType: action.isNatType
      }
    case SET_MANUAL_BOX_PROCESS:
      return {
        ...state,
        manualBoxProcess: action.manualBoxProcess
      }
    case SET_IS_DISCONNECT_LISTENED:
      return {
        ...state,
        isDisconnectListened: action.isDisconnectListened
      }
    case OPEN_DIALOG_FROM_SOCIAL:
      return {
        ...state,
        socialSettingDialogStatus: action.socialSettingDialogStatus
      }
    case UPDATE_LANGUAGE_FROM_SOCIAL:
      updateLanguage(action.language || 'en');
      return { ...state }
    case SET_SOUND_CARDS_LIST:
      return {
        ...state,
        currentSoundCard: action.currentSoundCard,
        soundCards: action.soundCards
      }
    case SET_RECORDING_DETAILS:
      return {
        ...state,
        recordingDetails: action.recordingDetails
      }
    case SET_HIT_FIREWALL_API:
      return {
        ...state,
        hitFirewallApi: action.hitFirewallApi
      }
  }

  return state;
}
);
